import { useLocation, useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

/**
 * Minimal AI search launcher: a round maroon magnifier bubble with "Ask AI"
 * below it. Tapping goes straight to the /assistant page.
 */
export default function AiSearchLauncher() {
  const loc = useLocation();
  const nav = useNavigate();

  if (loc.pathname.startsWith("/assistant") || loc.pathname.startsWith("/admin")) return null;

  return (
    <button
      onClick={() => nav("/assistant")}
      data-testid="ai-launcher-button"
      aria-label="Ask AI to find a home"
      className="fixed right-4 md:right-6 bottom-20 md:bottom-6 z-40 flex flex-col items-center gap-1 group"
    >
      <span className="w-12 h-12 rounded-full bg-[#7A1E2A] text-white shadow-[0_10px_26px_-8px_rgba(122,30,42,0.6)] flex items-center justify-center group-hover:scale-105 group-active:scale-95 transition-transform">
        <Search size={20} />
      </span>
      <span className="text-[11px] font-semibold brand-forest">Ask AI</span>
    </button>
  );
}
